import React from 'react';
import authService from '../services/authService';

const Login = ({ onLoginSuccess }) => {
    const handleLogin = async () => {
        try {
            await authService.login();
            onLoginSuccess();
        } catch (error) {
            console.error('Login failed:', error);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
                <h2 className="text-2xl font-bold text-center mb-6">Azure DevOps Tickets</h2>
                <p className="text-gray-600 mb-6 text-center">
                    Sign in with your Azure AD account to access your work items
                </p>
                <button
                    onClick={handleLogin}
                    className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                    Sign in with Microsoft
                </button>
            </div>
        </div>
    );
};

export default Login;